import React from 'react';
import PlaybooksPanel from '../../../platform/components/PlaybooksPanel';
import { canAdminTenant, callWorkGateway } from './shell/workGateway';

// ============================================================================
// CHA-633 — Playbooks as its own Intelligence tab (#/playbooks) in the InMocean shell.
// ============================================================================
// Mounts the platform PlaybooksPanel (reused, not rewritten) with this shell's gateway call. Admin-only,
// exactly as it was inline on Work: this tenant's admin or a platform admin. The gateway enforces the
// same on the server regardless; anyone else who reaches the tab sees why it is empty.
export default function PlaybooksHome({ userProfile }) {
  return (
    <div className="space-y-5 font-plex text-carbon-ink">
      <div>
        <h1 className="text-lg font-semibold tracking-[-0.01em] m-0">Playbooks</h1>
        <div className="font-plex-mono text-[10px] tracking-[0.12em] uppercase text-carbon-gray-50 mt-0.5">
          What Work sends, to whom, and how long it waits
        </div>
      </div>
      {canAdminTenant(userProfile)
        ? <PlaybooksPanel call={callWorkGateway} />
        : <p className="text-sm text-carbon-gray-60" data-testid="playbooks-admin-only">Playbooks are managed by this workspace's admins.</p>}
    </div>
  );
}
